export default __webpack_public_path__ + "static/media/1052.46b1ac38.png";